import { AppError } from "@/domain/errors/AppError";

export interface ApiClientErrorData {
	message: string;
	status: number;
	code?: string;
	details?: Record<string, unknown>;
	endpoint?: string;
	method?: string;
}

export class ApiClientError extends AppError {
	readonly isOperational = true;
	readonly code: string;
	public readonly status: number;
	public readonly details?: Record<string, unknown>;
	public readonly endpoint?: string;
	public readonly method?: string;

	constructor(error: ApiClientErrorData) {
		const message = error.endpoint
			? `${error.method || "GET"} ${error.endpoint}: ${error.message}`
			: error.message;
		super(message);
		this.name = "ApiClientError";
		this.status = error.status;
		this.code = error.code ?? "UNKNOWN";
		this.details = error.details;
		this.endpoint = error.endpoint;
		this.method = error.method;
	}
}
